import { useAppSettingStore } from '@/features/profile-setting/store/useAppSettingStore';

export const getFormattedDate = (
  date: Date | number | undefined,
  format: Intl.DateTimeFormatOptions
): string => {
  const locale = useAppSettingStore.getState().selectedLocale;
  return new Intl.DateTimeFormat(locale, format).format(date);
};
